import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import Divider from '../components/Divider';

// Updated menu data
const MENU_DATA = {
  special_offers: [
    { id: "so1", name: "Peshawari Chapli Kabab Deal", description: "3 Chapli Kababs + 3 Nan (Fresh Salad & Sauce)", price_small: "", price_large: "£24.99" },
  ],
  karahi: [
    { id: "k1", name: "Desi Chicken Karahi (Organic Chicken)", description: "Butt Special", price_small: "£19.99 ½kg", price_large: "£39.99 1kg" },
    { id: "k2", name: "Desi Chicken Karahi (Butter)", description: "", price_small: "£21.99 ½kg", price_large: "£41.99 1kg" },
    { id: "k3", name: "Charsi Chicken Karahi", description: "", price_small: "£15.99 ½kg", price_large: "£29.99 1kg" },
    { id: "k4", name: "Charsi Chicken Karahi (Butter)", description: "", price_small: "£16.99 ½kg", price_large: "£31.99 1kg" },
    { id: "k5", name: "Lamb Karahi (Butt Special)", description: "", price_small: "£19.99 ½kg", price_large: "£39.99 1kg" },
    { id: "k6", name: "Lamb Karahi", description: "", price_small: "£21.99 ½kg", price_large: "£41.99 1kg" },
    { id: "k7", name: "Charsi Lamb Karahi", description: "", price_small: "£17.99 ½kg", price_large: "£35.99 1kg" },
  ],
  bbq: [
    { id: "b1", name: "Charsi Tikka (Lamb/Chicken)", description: "", price_small: "£8.99 ¼kg (£17.99 ½kg)", price_large: "£33.99 1kg" },
    { id: "b2", name: "Charsi Chops (Lamb)", description: "", price_small: "£16.99 ½kg", price_large: "£33.99 1kg" },
    { id: "b3", name: "Mix Grill", description: "Served with Fresh Salad & Afghani Nan", price_small: "", price_large: "£29.99" },
    { id: "b4", name: "Chicken Tikka (Leg) Butt Special", description: "", price_small: "", price_large: "£3.49" },
    { id: "b5", name: "Chicken Malai Botti", description: "", price_small: "£14.99 ½kg", price_large: "£29.99 1kg" },
    { id: "b6", name: "Seekh Kabab Portion (Lamb/Chicken)", description: "", price_small: "", price_large: "£3.99" },
    { id: "b7", name: "Chicken Cheese Seekh Kabab", description: "", price_small: "", price_large: "£3.99" },
    { id: "b8", name: "French Fries", description: "", price_small: "", price_large: "£2.99" },
    { id: "b9", name: "Chicken Nuggets (8 Pcs) & Fries", description: "", price_small: "", price_large: "£5.99" },
  ],
  bbq_platter: [
    { id: "bp1", name: "Butt Special BBQ Platter (Small)", description: "1 Seekh Charsi Tikka, 3 pcs Chops, 2 pcs Chicken Leg, 2 pcs Small Chapli Kabab, 1 pcs Lamb/Chicken Seekh Kabab. Served with Kabuli Pulao & 1 Large Nan (2-4 Serving)", price_small: "£41.99", price_large: "" },
    { id: "bp2", name: "Butt Special BBQ Platter (Large)", description: "2 Seekh Charsi Tikka, 6 pcs Chops, 4 pcs Chicken Leg, 3 pcs Small Chapli Kabab, 2 pcs Lamb/Chicken Seekh Kabab. Served with Kabuli Pulao & Jug Lemon Soda (4-6 Serving)", price_small: "", price_large: "£69.99" },
  ],
  rice: [
    { id: "r1", name: "Kabuli Pulao", description: "", price_small: "", price_large: "£9.99" },
    { id: "r2", name: "Kabuli Mahecha Pulao", description: "", price_small: "", price_large: "£11.99" },
    { id: "r3", name: "Chicken Pulao", description: "", price_small: "£7.99", price_large: "£9.99" },
    { id: "r4", name: "Chicken Biryani", description: "", price_small: "", price_large: "£6.99" },
    { id: "r5", name: "Matka Biryani", description: "", price_small: "", price_large: "£9.99" },
    { id: "r6", name: "Plain Rice", description: "", price_small: "", price_large: "£4.99" },
  ],
  veg: [
    { id: "v1", name: "Special Dall Masha Fry", description: "", price_small: "£5.99", price_large: "£7.99" },
    { id: "v2", name: "Lobiya Dall", description: "", price_small: "£5.99", price_large: "£7.99" },
    { id: "v3", name: "Mix Vegetable", description: "", price_small: "£5.99", price_large: "£7.99" },
    { id: "v4", name: "Greek Salad", description: "", price_small: "", price_large: "£3.99" },
    { id: "v5", name: "Fresh Salad", description: "", price_small: "", price_large: "£1.99" },
  ],
  taka_tuk: [
    { id: "t1", name: "Maghaz Karahi", description: "", price_small: "", price_large: "£14.99" },
    { id: "t2", name: "Qeema Fry", description: "", price_small: "£12.99 ½kg", price_large: "£25.99 1kg" },
    { id: "t3", name: "Seekh Kabab Karahi (Lamb/Chicken)", description: "", price_small: "£13.99 ½kg", price_large: "£21.99 1kg" },
    { id: "t4", name: "Special Daal Ghost Karahi", description: "", price_small: "£11.99 ½kg", price_large: "£19.99 1kg" },
  ],
  chapli_kabab: [
    { id: "c1", name: "Peshawari Chappli Kabab", description: "", price_small: "", price_large: "£6.99" },
    { id: "c2", name: "Peshawari Chappli Kabab (Egg)", description: "", price_small: "", price_large: "£7.99" },
  ],
  naan: [
    { id: "n1", name: "Peshawari Naan", description: "", price_small: "£1.99", price_large: "£2.99" },
    { id: "n2", name: "Peshawari Roti", description: "", price_small: "£1.99", price_large: "£2.99" },
    { id: "n3", name: "Roghni Naan", description: "", price_small: "", price_large: "£2.49" },
    { id: "n4", name: "Garlic Naan", description: "", price_small: "", price_large: "£2.49" },
    { id: "n5", name: "Kalwangi Naan", description: "", price_small: "", price_large: "£2.49" },
  ],
  beverages: [
    { id: "bv1", name: "Lemon Soda", description: "", price_small: "", price_large: "£3.49" },
    { id: "bv2", name: "Mint Soda", description: "", price_small: "", price_large: "£3.49" },
    { id: "bv3", name: "Jug of Soda (Lemon/Mint)", description: "", price_small: "", price_large: "£7.99" },
    { id: "bv4", name: "Lassi (Sweet/Mango/Saltish)", description: "", price_small: "", price_large: "£3.49" },
    { id: "bv5", name: "Jug of Lassi (Sweet/Mango/Saltish)", description: "", price_small: "", price_large: "£7.99" },
    { id: "bv6", name: "Soft Drinks (Bottle 350ml)", description: "", price_small: "", price_large: "£2.49" },
    { id: "bv7", name: "Soft Drinks (Can)", description: "", price_small: "", price_large: "£1.99" },
  ],
  special: [
    { id: "s1", name: "Lamb Sajji (Full)", description: "For 8-10 Persons - Special On Demand", price_small: "", price_large: "£275.00" },
    { id: "s2", name: "Lamb Sajji (Half)", description: "For 4-6 Persons - Special On Demand", price_small: "", price_large: "£150.00" },
    { id: "s3", name: "Finger Fish (Season)", description: "", price_small: "£11.99 ½kg", price_large: "£21.99 1kg" },
  ]
};

const MenuItem = ({ item }) => (
  <div className="flex items-baseline py-3 border-b border-gray-200 last:border-0 group" data-testid={`menu-item-${item.id}`}>
    <div className="flex-shrink-0 flex-1">
      <h4 className="text-black font-medium group-hover:text-brand-red transition-colors">
        {item.name}
      </h4>
      {item.description && (
        <p className="text-gray-500 text-sm mt-1">{item.description}</p>
      )}
    </div>
    <div className="flex-shrink-0 text-right ml-4">
      {item.price_small && (
        <p className="text-brand-red font-semibold text-sm">{item.price_small}</p>
      )}
      {item.price_large && (
        <p className="text-brand-red font-semibold text-sm">{item.price_large}</p>
      )}
    </div>
  </div>
);

const MenuCategory = ({ title, items }) => (
  <div className="mb-8" data-testid={`category-${title.toLowerCase().replace(/\s+/g, '-')}`}>
    <h3 className="font-serif text-xl md:text-2xl font-bold text-brand-red mb-4 pb-2 border-b-2 border-brand-red/30">
      {title}
    </h3>
    <div className="space-y-1">
      {items.map((item) => (
        <MenuItem key={item.id} item={item} />
      ))}
    </div>
  </div>
);

const Menu = () => {
  const [activeTab, setActiveTab] = useState('special_offers');

  const categoryLabels = {
    special_offers: 'Special Offers',
    karahi: 'Karahi',
    bbq: 'Bar B Q',
    bbq_platter: 'BBQ Platter',
    rice: 'Rice Special',
    veg: 'Veg Special',
    taka_tuk: 'Taka Tuk',
    chapli_kabab: 'Chapli Kabab',
    naan: 'Naan Special',
    beverages: 'Beverages',
    special: 'Special Items'
  };

  return (
    <main className="pt-24 min-h-screen bg-white" data-testid="menu-page">
      {/* Hero Section */}
      <section className="py-16 px-6 text-center bg-gray-50">
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-black mb-4">
          OUR <span className="text-brand-red">MENU</span>
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Traditional, authentic recipes with a contemporary twist. Each dish is prepared with the finest ingredients 
          and our signature blend of exotic spices.
        </p>
      </section>

      <Divider className="py-6" />

      {/* Menu Content */}
      <section className="py-8 px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="flex flex-wrap justify-center gap-1 md:gap-2 mb-8 bg-transparent h-auto p-0">
              {Object.entries(categoryLabels).map(([key, label]) => (
                <TabsTrigger 
                  key={key}
                  value={key}
                  data-testid={`tab-${key}`}
                  className="px-2 md:px-4 py-2 text-xs uppercase tracking-wider font-medium border border-gray-300 text-gray-700 data-[state=active]:bg-brand-red data-[state=active]:text-white data-[state=active]:border-brand-red hover:border-brand-red transition-all rounded-none bg-white"
                >
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>

            {Object.entries(MENU_DATA).map(([category, items]) => (
              <TabsContent key={category} value={category} className="mt-0">
                <div className="bg-white border border-gray-200 p-4 md:p-8 shadow-sm">
                  <MenuCategory 
                    title={categoryLabels[category] || category} 
                    items={items} 
                  />
                </div>
              </TabsContent>
            ))}
          </Tabs>

          {/* Note */}
          <div className="mt-12 text-center">
            <p className="text-gray-500 text-sm italic">
              Please allow approximately 25 minutes for the preparation of freshly cooked food.
            </p>
            <p className="text-gray-400 text-xs mt-2">
              Note: We do not guarantee our dishes are free from nuts.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6 bg-brand-red">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Order?
          </h2>
          <p className="text-white/80 mb-8">
            Call us now to place your order for dine-in, takeaway, or delivery.
          </p>
          <a 
            href="tel:01582517786"
            data-testid="menu-call-btn"
            className="inline-flex items-center gap-3 bg-white text-brand-red px-10 py-4 font-semibold text-sm tracking-wider uppercase hover:bg-gray-100 transition-all duration-300"
          >
            <span>Call 01582 517786</span>
          </a>
        </div>
      </section>
    </main>
  );
};

export default Menu;
